import React from 'react';
import "./enterAge.css";
function EnterAge() {
  return (
    <div>
        <h1 className='container'>Enter your age here.</h1>
    </div>
  )
}

export default EnterAge